module.exports = __webpack_public_path__ + "img/tips-gear-download.93b5c3d5.svg";